<template>
  <div data-test-id="ChangePasswordPage" class="ems-page">
    <NavBar>
      <template #left>
        <div class="text-red" @click="onBackClick">Back</div>
      </template>
      <template #center>
        <span>
          <b>Change Password</b>
        </span>
      </template>
    </NavBar>
    <b-container>
      <br />
      <b-row align-h="center">
        <b-col lg="6" md="6" sm="12">
          <b-alert id="password__error-required" :show="!!errorMessage" variant="danger">{{ errorMessage }}</b-alert>
          <b-form id="password_form" @submit.prevent="onSubmit()">
            <b-form-group :invalid-feedback="currentPasswordFieldFeedback">
              <b-form-input
                id="current_password"
                v-model="form.currentPassword"
                data-cy-password
                type="password"
                placeholder="Current Password"
                :state="isCurrentPasswordValid"
                @input="onType()"
              />
            </b-form-group>
            <b-form-group :invalid-feedback="newPasswordFieldFeedback">
              <b-form-input
                id="new_password"
                v-model="form.newPassword"
                data-cy-password
                type="password"
                placeholder="New Password"
                :state="isNewPasswordValid"
                @input="onType()"
              />
            </b-form-group>
            <b-form-group :invalid-feedback="verifyPasswordFieldFeedback">
              <b-form-input
                id="verify_password"
                v-model="form.verifyPassword"
                data-cy-password
                type="password"
                placeholder="Confirm New Password"
                :state="isVerifyPasswordValid"
                @input="onType()"
              />
            </b-form-group>

            <b-button
              id="change_password_button"
              data-cy-change-password-button
              variant="danger"
              block
              class="mt-5 mb-5"
              @click.prevent="onSubmit()"
              >Change Password</b-button
            >
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import NavBar from "@/App/components/NavBar.vue";
export default {
  name: "ChangePassword",
  components: { NavBar },
  data() {
    return {
      form: {
        currentPassword: "",
        newPassword: "",
        verifyPassword: "",
      },
    };
  },
  computed: {
    ...mapState("ChangePassword", [
      "currentPasswordError",
      "newPasswordError",
      "verifyPasswordError",
      "errorMessage",
      "isLoading",
    ]),
    isCurrentPasswordValid() {
      return this.currentPasswordError ? false : undefined;
    },
    currentPasswordFieldFeedback() {
      return this.currentPasswordError;
    },
    isNewPasswordValid() {
      return this.newPasswordError ? false : undefined;
    },
    newPasswordFieldFeedback() {
      return this.newPasswordError;
    },
    isVerifyPasswordValid() {
      return this.verifyPasswordError ? false : undefined;
    },
    verifyPasswordFieldFeedback() {
      return this.verifyPasswordError;
    },
  },
  methods: {
    ...mapActions("ChangePassword", ["changePassword"]),
    onBackClick() {
      this.$router.push({ name: "settings" });
    },
    onSubmit() {
      this.changePassword(this.form);
    },
    onType() {
      this.$store.commit("ChangePassword/CLEAR_ERRORS");
    },
  },
};
</script>

<style scoped>
.text-red {
  color: red;
}
</style>
